// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"160":"17a36d350adf70b0","960":"c2fedcf09be623b7","996":"170fca9eb8926555"}[chunkId] + ".js";
};